import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  Td,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { FaEllipsis } from 'react-icons/fa6';
import { LuChevronRight } from 'react-icons/lu';
import { MdBlockFlipped } from 'react-icons/md';
import { R$ } from 'shared/helpers/currency';
import { Contract } from 'shared/models/contract';
import { useFinancialContext } from '../../FinancialContext';
import ContractStatusBadge from '../atoms/ContractStatusBadge/ContractStatusBadge';
import DeleteContractMenuItem from '../atoms/DeleteContractMenuItem';
import PlanBadge from '../atoms/ServiceBadge/PlanBadge';
import ToggleContractStatusMenuItem from '../atoms/ToggleContractStatusMenuItem';

interface ContractTableLineProps {
  contract: Contract;
  contractTypeName?: string;
  loading?: boolean;
}

const ContractTableLine = ({
  contract,
  contractTypeName = '',
  loading,
}: ContractTableLineProps) => {
  const { openContractDetails } = useFinancialContext();
  const handleClick = () => {
    if (contract.id) {
      openContractDetails(contract);
    }
  };
  return (
    <>
      <Td>
        <Text
          bg={loading ? 'yGray.50' : ''}
          p="1"
          borderRadius="8px"
          textColor={loading ? 'transparent' : 'yGray.600'}
        >
          {contract.id || 0}
        </Text>
      </Td>
      <Td>
        {loading ? (
          <Text bg="yGray.50" p="1" borderRadius="8px" textColor="transparent">
            {contract.selectedPeriodicity}
          </Text>
        ) : (
          <Tooltip label={contractTypeName}>
            <Text
              p="1"
              borderRadius="8px"
              textColor={loading ? 'transparent' : 'yGray.600'}
            >
              {contractTypeName}
            </Text>
          </Tooltip>
        )}
      </Td>
      <Td>
        <PlanBadge loading={loading} key={contract.id} contract={contract} />
      </Td>
      <Td>
        <Text
          bg={loading ? 'yGray.50' : ''}
          p="1"
          borderRadius="8px"
          textColor={loading ? 'transparent' : 'yGray.600'}
        >
          {contract.created_at?.format('DD/MM/YYYY')}
        </Text>
      </Td>
      <Td>
        <Text
          bg={loading ? 'yGray.50' : ''}
          p="1"
          borderRadius="8px"
          textColor={loading ? 'transparent' : 'yGray.600'}
        >
          {contract.expiration_date?.format('DD/MM/YYYY')}
        </Text>
      </Td>
      <Td>
        <Text
          bg={loading ? 'yGray.50' : ''}
          p="1"
          borderRadius="8px"
          textColor={loading ? 'transparent' : 'yGray.600'}
        >
          {R$(contract.products.reduce((sum, p) => sum + p.value, 0))}
        </Text>
      </Td>
      <Td>
        <ContractStatusBadge
          loading={loading}
          contract={contract}
        ></ContractStatusBadge>
      </Td>
      <Td>
        <Menu variant="actions">
          <MenuButton as={Button} isDisabled={loading} variant="plainIcon">
            <FaEllipsis />
          </MenuButton>
          <MenuList>
            <ToggleContractStatusMenuItem
              icon={<MdBlockFlipped />}
              contract={contract}
              shouldOpenContract={false}
            />
            <DeleteContractMenuItem
              contractId={contract.id}
              color="yRed.500"
              icon={<FaRegTrashAlt />}
            />
          </MenuList>
        </Menu>
      </Td>
      <Td>
        <Button
          isDisabled={loading}
          variant="plainIcon"
          onClick={() => handleClick()}
        >
          <LuChevronRight />
        </Button>
      </Td>
    </>
  );
};
export default ContractTableLine;
